import {$config} from "@/common/constants";
import http from "@utils/http";

export const utils = {
	getSelector: function (el) {
		if(!el) return "";
		if (!(el instanceof Element))
			return;
		var path = [];
		while (el && el.nodeType === Node.ELEMENT_NODE) {
			var selector = el.nodeName.toLowerCase();
			if (el.id) {
				selector += "#" + el.id;
				path.unshift(selector);
				break;
			} else {
				var sib = el, nth = 1;
				while (sib = sib.previousElementSibling) {
					if (sib.nodeName.toLowerCase() == selector)
						nth++;
				}
				if (nth != 1)
					selector += ":nth-of-type(" + nth + ")";
			}
			path.unshift(selector);
			el = el.parentNode;
		}
		return path.join(" > ");
	},
	getHost: function (url) {
		var result = url.match(/[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/);
		if (result) {
			return result[0];
		}
		return "";
	},
	//键值对转换字符串
	jsonToUrl: function (data) {
		var arr = [];
		for (var i in data) {
			let value = data[i];
			if(Object.prototype.toString.call(value) === "[object Object]"){
				value = JSON.stringify(value);
			}else {
				value = encodeURIComponent(value);
			}
			arr.push(i + "=" + value);
		}
		return arr.join("&");
	},
	//查询参数转成JSON
	urlToJson: function (url) {
		var result = {}, params;
		if (typeof url !== "string" || !url) {
			return result;
		}
		var index = url.indexOf("?");
		if (index > -1) {
			url = decodeURIComponent(url);
			params = url.substring(index + 1).split("&");
			for (var i = 0; i < params.length; i++) {
				var keyValue = params[i].split("=");
				result[keyValue[0]] = keyValue[1];
			}
		}
		return result;
	},
	// //获取查询参数
	// getParam: function (url, key) {
	//     return utils.urlToJson(url)[key];
	// },
	// //将数据存储到本地
	// saveToLocal: function (info) {
	//     var key = $config.LOCAL_QUEUE_NAME;
	//     var queue = [];
	//     var local = window.localStorage ? localStorage : docCookies;
	//     if (!window.JSON) {
	//         window.JSON = polyfill.JSON
	//     }
	//     try {
	//         queue = JSON.parse(local.getItem(key));
	//         queue.push(info);
	//         local.setItem(key, JSON.stringify(queue));
	//     } catch (e) {
	//         console.log(e);
	//     }
	// },

	isInnerSite:function(url){
		let innerSites = [];
		for(var key in $config.SITES){
			innerSites = innerSites.concat($config.SITES[key]);
		}
		const host = utils.getHost(url).toLowerCase();
		let result = false;
		for(let i=0;i<innerSites.length;i++){
			if(innerSites[i] == host){
				result = true;
				break;
			}
		}
		return result;
	},

	getLatestReferrer:function(url){
		if(!url){
			return "";
		}
		if(!utils.isInnerSite(url)){
			return url;
		}
		return "";
	},

	getElementType:function(target){
		var tagName = target.tagName;
		if(tagName == "A"){
			return "A";
		}
		if(tagName == "BUTTON"){
			return "BUTTON";
		}
		if(tagName =="INPUT"){
			var type = target.getAttribute("type").toLowerCase();
			if(type =="submit"){
				return "submit";
			}
			if(type=="button"){
				return "input_button";
			}
		}

		return "";
	},

	getTrafficSource: function (url) {
		if (typeof url !== "string" || !url) {
			//直接访问
			return "direct";
		}

		var host = utils.getHost(url).toLowerCase();

		// if(host == document.location.host){
		//     //内部应用
		//     return "innerApp"
		// }
		//
		// if(utils.isInnerSite(url)){
		//     //其它应用
		//     return  "otherApp"
		// }
		//站外链接
		var result = "other";

		//搜索引擎字典
		var dict = {
			"google.com": "google",
			"baidu.com": "baidu",
			"yahoo.com": "yahoo",
			"so.com": "360",
			"sogou.com": "sogou",
			"bing.com": "bing",
			"sm.cn":"sm"
		};

		for (var key in dict) {
			if (host.indexOf(key) > -1) {
				result = "search_engine";
			}
		}
		return result;
	},

	// mergeObjects: function () {
	//     var result = {};
	//     for (var i = 0; i < arguments.length; i++) {
	//         for (var key in arguments[i]) {
	//             result[key] = arguments[i][key];
	//         }
	//     }
	//     return result;
	// },
	getElementPosition: function (element) {
		var left = 0, top = 0;
		try {
			var ref = element.getBoundingClientRect();
			var doc = document.documentElement;
			left = ref.left + doc.scrollLeft;
			top = ref.top + doc.scrollTop;
		} catch (e) {
			left = element.offsetLeft;
			top = element.offsetTop;
			var current = element.offsetParent;
			while (current !== null) {
				left += current.offsetLeft;
				top += current.offsetTop;
				current = current.offsetParent;
			}
		}

		return {
			x: left,
			y: top
		};
	},
	uuid: function (len, radix) {
		var chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
		var uuid = [], i;
		radix = radix || chars.length;

		if (len) {
			for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
		} else {
			var r;
			uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
			uuid[14] = "4";
			for (i = 0; i < 36; i++) {
				if (!uuid[i]) {
					r = 0 | Math.random() * 16;
					uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
				}
			}
		}
		return uuid.join("");
	},
	now:function(){
		return new Date().getTime();
	},
	//日期格式化
	formatDate(date, fmt) {
		let o = {
			"M+": date.getMonth() + 1, // 月份
			"d+": date.getDate(), // 日
			"h+": date.getHours(), // 小时
			"m+": date.getMinutes(), // 分
			"s+": date.getSeconds(), // 秒
			"q+": Math.floor((date.getMonth() + 3) / 3), // 季度
			S: date.getMilliseconds(), // 毫秒
		};
		if (/(y+)/.test(fmt))
			fmt = fmt.replace(
				RegExp.$1,
				(date.getFullYear() + "").substr(4 - RegExp.$1.length)
			);
		for (let k in o)
			if (new RegExp("(" + k + ")").test(fmt))
				fmt = fmt.replace(
					RegExp.$1,
					RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
				);
		return fmt;
	},
	//发送数据
	sendData: function (url, data) {
		return new Promise(function (resolve, reject) {
			//优先使用sendBeacon，如果没有，使用ajax
			if (window.navigator.sendBeacon) {
				const result = window.navigator.sendBeacon(url, data);
				result ? resolve(result) : reject(result);
			}else{
				http.post(url, data).then(resolve,reject);
			}
		});
	},
	//判断是否是IE9
	isIE9: function () {
		return navigator.appName == "Microsoft Internet Explorer" && navigator.appVersion.match(/9./i)=="9.";	
	},
};
